<mps-maintenance-lock
  [viewModel]="data.viewModel()"
  (switchOrganization)="data.switchOrganization()"
  (logoutRequested)="data.logout()"
/>
